import type { BaseDataSourceConfiguration, DataSource } from ".";

export interface FixedDataTableConfiguration
    extends BaseDataSourceConfiguration {
    type: DataSource.FIXED_DATA;
    settings: FixedDataTableSettings;
}

export type FixedData = { [key in string]: string };
export interface FixedDataTableSettings {
    data: FixedData;
}

export const getFixedData = async (
    settings: FixedDataTableSettings,
): Promise<FixedData> => {
    return settings.data;
};
